export default {
    it: {
        "question": "Scrivi la domanda che vuoi porre",
        "remaining-characters": "Ti rimangono: ",
        "characters": " caratteri",
        "question-custom": "Scrivi la tua domanda",
        "error_flux_code":  "Codice invio flusso trasmissioni"
    },
    en: {
        "question": "Write the question you want to ask",
        "remaining-characters": "You have ",
        "characters": " characters",
        "question-custom": "Write your question",
        "error_flux_code":  "Transmission flow sending code"
    }
}